<app-protocolo-pesquisa
    [tiposConteudo]="tiposConteudo" 
    [formatoArquivo]="formatoArquivo"
    [textoBotaoEnvio]="'Enviar arquivo de informações de risco'"
    [routerLinkEnvioLote]="['/atualizacao-info-risco/envio']"
    [textoBotaoEnvio2]="'Enviar arquivo de posição da carteira em recup.'"
    [routerLinkEnvioLote2]="['/acompanhamento-processual/envio']"
></app-protocolo-pesquisa>